import React from 'react';

const LoadingSpinner = ({ label = 'Cargando...', size = 48 }) => (
  <div className="d-flex flex-column align-items-center justify-content-center text-center text-secondary py-4">
    <div
      className="spinner-border text-secondary"
      role="status"
      aria-label={label}
      style={{ width: `${size}px`, height: `${size}px` }}
    ></div>
    <div className="mt-2">{label}</div>
  </div>
);

export default LoadingSpinner;
